export default {
  totalLabel: 'font-bold! rounded-xs! overflow-hidden! text-end',
  totalAmount: 'bg-[#0000000F]! px-2 rounded-xs py-0.5',
  totalAmountRegularFont: 'font-bold! text-[#000000]! ] text-base rounded-xs',
  totalAmountRegularFont2: 'text-[#000000]! text-sm rounded-xs opacity-60',
};
